import MarqueeClassic from "./MarqueeClassic";

export const Marquee = {
    "classic":MarqueeClassic
}